<template>
  <div class="vehicle-picker">
    <label v-if="!creatingNew">
      Автомобиль
      <select
        :value="modelValue"
        class="input"
        :disabled="disabled || !vehicles.length"
        required
        @change="onSelect"
      >
        <option value="" disabled>Выберите автомобиль</option>
        <option v-for="vehicle in vehicles" :key="vehicle.id" :value="String(vehicle.id)">
          {{ vehicle.make }}
        </option>
      </select>
    </label>

    <button
      v-if="!creatingNew"
      type="button"
      class="btn btn-secondary vehicle-picker-toggle"
      :disabled="disabled"
      @click="startCreate"
    >
      Добавить новый
    </button>

    <div v-else class="vehicle-picker-create panel">
      <p class="vehicle-picker-create-title">Новый автомобиль</p>
      <VehicleForm
        :make="newMake"
        :equipment="newEquipment"
        :photos="newPhotos"
        :disabled="disabled"
        @update:make="newMake = $event"
        @update:equipment="newEquipment = $event"
        @update:photos="newPhotos = $event"
      />
      <div class="vehicle-picker-create-actions">
        <button type="button" class="btn btn-secondary" :disabled="disabled" @click="cancelCreate">
          Отмена
        </button>
      </div>
    </div>

    <p v-if="loadError" class="error-message">{{ loadError }}</p>
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { fetchVehicles } from '../api/vehicles'
import VehicleForm from './VehicleForm.vue'

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  mode: {
    type: String,
    default: 'select',
    validator: (value) => ['select', 'create'].includes(value),
  },
})

const emit = defineEmits(['update:modelValue', 'quick-create'])

const vehicles = ref([])
const loadError = ref('')
const creatingNew = ref(props.mode === 'create')
const newMake = ref('')
const newEquipment = ref('')
const newPhotos = ref([])

watch(
  () => [creatingNew.value, newMake.value, newEquipment.value, newPhotos.value],
  () => {
    if (!creatingNew.value) return
    emit('quick-create', {
      make: newMake.value,
      equipment: newEquipment.value,
      photos: newPhotos.value,
    })
  },
  { deep: true }
)

function onSelect(event) {
  emit('update:modelValue', event.target.value)
}

function startCreate() {
  creatingNew.value = true
  emit('update:modelValue', '')
  emit('quick-create', {
    make: newMake.value,
    equipment: newEquipment.value,
    photos: newPhotos.value,
  })
}

function cancelCreate() {
  creatingNew.value = false
  newMake.value = ''
  newEquipment.value = ''
  newPhotos.value = []
  emit('quick-create', null)
}

async function loadVehicles() {
  try {
    const { data } = await fetchVehicles()
    vehicles.value = data
  } catch {
    loadError.value = 'Не удалось загрузить список автомобилей'
  }
}

onMounted(loadVehicles)

defineExpose({ reload: loadVehicles, vehicles })
</script>

<style scoped>
.vehicle-picker {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.vehicle-picker label {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  font-weight: 600;
}

.vehicle-picker-toggle {
  align-self: flex-start;
}

.vehicle-picker-create {
  padding: 1rem;
}

.vehicle-picker-create-title {
  margin: 0 0 0.75rem;
  font-weight: 600;
}

.vehicle-picker-create-actions {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.75rem;
}
</style>
